


















































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import companyApi from "@/api/companyApi";
import Company from "@/model/company";
import click2Top from "@/common/directives/click2Top";
import QUserSelect from "@/common/qUserSelect.vue";
import {namespace} from "vuex-class";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import postalCodeApi from "@/api/postalCodeApi";
import _ from "lodash";
import {compareWithKeys} from "@/common/utils";
const authStore = namespace("Auth");
@Component({
  name: "CompanyInfoEdit",
  directives: {
    click2Top,
  },
  components: {
    QErrors,
    QUserSelect,
  },
})
export default class CompanyInfoEdit extends Vue {
  @Prop({
    default: () => {
      return new Company();
    },
  })
  company: Company;

  @authStore.Getter
  public isOwner;
  @authStore.Getter
  public isManager;

  public errors ={};
  public companyInit = new Company();

  mounted() {
    this.companyInit = _.cloneDeep(this.company)
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$emit('refreshData');
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$emit('refreshData');
    }
  }

  public async update() {
    const result = await companyApi.update(this.company);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t("companies.updated_fail"),
      });
      this.errors = result.meta.errors;
    } else {
      this.errors = {};
      qNotify.success({
        text: this.$t("companies.created"),
      });
      this.$emit('refreshData');
    }
  }

  public async getPostalCode() {
    if (this.company.zip_code.trim() === '') {
      this.company.address1 = "";
      this.errors = {};
      return;
    }

    const result = await postalCodeApi.show(this.company.zip_code);
    if (result) {
      this.company.address1 = result.prefecture + result.area + result.address;
      this.errors = {};
    } else {
      this.company.address1 = "";
      this.errors = {
        zip_code: [this.$t("common.zip_code_not_found")],
      };
    }
  }

  public isChanged() {
    return compareWithKeys(this.company, this.companyInit, [
      'name',
      'zip_code',
      'address1',
      'address2',
      'phone',
      'fax',
      'representative_user_id',
      'bank_info',
      'transfer_date_number',
    ])
  }
}
